import { Injectable } from '@angular/core';

@Injectable()
export class PanchangPopupHelperService {
    content: any[] = [];
    date;
    constructor() { }

}
